import {IconProps} from './types';

export const Whatsapp: React.FC<IconProps> = ({
    className,
    width = 24,
    height = 24,
    stroke = 'currentColor'
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
    >
        <path
            d="M16.4938 13.1338C16.4209 13.0141 16.2274 12.9403 15.9367 12.7971C15.646 12.6539 14.2142 11.9537 13.9486 11.8582C13.6831 11.7627 13.487 11.7133 13.2935 12.0022C13.0999 12.2912 12.542 12.9403 12.3719 13.1304C12.2018 13.3204 12.0326 13.3473 11.7419 13.2032C10.8839 12.8648 10.0911 12.38 9.39888 11.7705C8.76344 11.1894 8.21826 10.5167 7.78135 9.77467C7.60779 9.48656 7.76312 9.33037 7.90891 9.18631C8.21397 8.90823 8.4611 8.57263 8.63611 8.19879C8.67497 8.11923 8.69312 8.03115 8.68888 7.94271C8.68463 7.85427 8.65812 7.76834 8.61181 7.69287C8.54152 7.54969 7.95924 6.12827 7.71713 5.55381C7.44291 4.89777 6.22022 4.87521 5.72819 5.40802C4.17574 7.09237 4.53413 9.00061 5.90174 10.8012C6.04753 10.9939 7.91498 14.0042 10.8724 15.1601C13.8297 16.316 13.8297 15.9298 14.3634 15.8812C15.8968 15.7432 16.9346 13.8654 16.4973 13.1364M10.5001 0.520707C7.86472 0.513089 5.33395 1.55121 3.46306 3.40729C1.59218 5.26337 0.533986 7.78581 0.520668 10.4212C0.519263 12.5098 1.18544 14.5442 2.42196 16.2274L1.17584 19.9051L5.01054 18.6859C6.51077 19.6704 8.2485 20.2325 10.0411 20.3134C11.8337 20.3942 13.615 19.9906 15.1977 19.1451C16.7804 18.2995 18.1062 17.0433 19.0356 15.5083C19.965 13.9734 20.4638 12.2164 20.4795 10.422C20.4662 7.7866 19.408 5.26407 17.5372 3.40785C15.6663 1.55163 13.1355 0.513319 10.5001 0.520707Z"
            stroke={stroke}
            strokeWidth="1.04133"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
